import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modePlagalSecond';
const args = {};

export class ModePlagalSecond extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
